import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import { releasesAPI } from '../../services/inovacaoAPI';

export function ReleaseLista() {
  const [items, setItems] = useState([]);
  useEffect(() => { releasesAPI.listar().then(setItems).catch(() => {}); }, []);
  return (
    <div style={{ padding: 32 }}>
      <h1>Releases mensais do GNI</h1>
      <p style={{ color: '#777' }}>Compilações mensais de projetos concluídos. Rascunhos são criados automaticamente dia 1 de cada mês.</p>
      <table style={{ width: '100%', background: '#fff', borderCollapse: 'collapse' }}>
        <thead style={{ background: '#f7f7f7' }}>
          <tr>
            <th style={{ padding: 12, textAlign: 'left' }}>Período</th>
            <th style={{ padding: 12, textAlign: 'left' }}>Título</th>
            <th style={{ padding: 12, textAlign: 'left' }}>Projetos</th>
            <th style={{ padding: 12, textAlign: 'left' }}>Status</th>
          </tr>
        </thead>
        <tbody>
          {items.map((r) => (
            <tr key={r.id} style={{ borderTop: '1px solid #eee' }}>
              <td style={{ padding: 12 }}>{String(r.periodo_mes).padStart(2, '0')}/{r.periodo_ano}</td>
              <td style={{ padding: 12 }}>
                <Link to={`/inovacao/releases/${r.id}`} style={{ color: 'var(--brand, #20a490)', textDecoration: 'none' }}>
                  {r.titulo}
                </Link>
              </td>
              <td style={{ padding: 12 }}>{r.projetos?.length || 0}</td>
              <td style={{ padding: 12 }}>
                <span style={{ background: r.publicado_em ? '#27ae60' : '#f39c12', color: '#fff',
                               padding: '2px 10px', borderRadius: 12, fontSize: '0.8rem' }}>
                  {r.publicado_em ? 'publicado' : 'rascunho'}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export function ReleaseDetalhe() {
  const { id } = useParams();
  const [r, setR] = useState(null);
  const [form, setForm] = useState({});

  async function carregar() {
    const d = await releasesAPI.obter(id);
    setR(d);
    setForm({ titulo: d.titulo, introducao: d.introducao || '', aprendizados_do_mes: d.aprendizados_do_mes || '' });
  }
  useEffect(() => { carregar().catch(() => {}); }, [id]);

  if (!r) return <div style={{ padding: 32 }}>Carregando…</div>;

  async function salvar() {
    try { await releasesAPI.atualizar(id, form); toast.success('Salvo'); await carregar(); }
    catch (e) { toast.error(e.response?.data?.detail || 'Erro'); }
  }
  async function publicar() {
    try { await releasesAPI.publicar(id); toast.success('Publicado'); await carregar(); }
    catch (e) { toast.error(e.response?.data?.detail || 'Erro'); }
  }

  const editavel = !r.publicado_em;

  return (
    <div style={{ padding: 32, maxWidth: 900 }}>
      <Link to="/inovacao/releases" style={{ color: 'var(--brand, #20a490)' }}>← Releases</Link>
      <h1>{r.titulo}</h1>

      {!editavel && <p><em>Publicado em {new Date(r.publicado_em).toLocaleString('pt-BR')}.</em></p>}

      <div style={{ background: '#fff', padding: 24, borderRadius: 8, marginBottom: 16 }}>
        <label style={{ display: 'block', marginBottom: 4, fontWeight: 500 }}>Título</label>
        <input style={{ width: '100%', padding: 10, marginBottom: 16, borderRadius: 4, border: '1px solid #ccc' }}
               readOnly={!editavel} value={form.titulo || ''}
               onChange={(e) => setForm({ ...form, titulo: e.target.value })} />

        <label style={{ display: 'block', marginBottom: 4, fontWeight: 500 }}>Introdução</label>
        <textarea style={{ width: '100%', padding: 10, minHeight: 80, marginBottom: 16, borderRadius: 4, border: '1px solid #ccc' }}
                  readOnly={!editavel} value={form.introducao || ''}
                  onChange={(e) => setForm({ ...form, introducao: e.target.value })} />

        <label style={{ display: 'block', marginBottom: 4, fontWeight: 500 }}>Aprendizados do mês</label>
        <textarea style={{ width: '100%', padding: 10, minHeight: 80, marginBottom: 16, borderRadius: 4, border: '1px solid #ccc' }}
                  readOnly={!editavel} value={form.aprendizados_do_mes || ''}
                  onChange={(e) => setForm({ ...form, aprendizados_do_mes: e.target.value })} />

        {editavel && (
          <>
            <button onClick={salvar}
                    style={{ background: 'var(--brand, #20a490)', color: 'var(--brand-ink, #fff)', padding: '10px 20px',
                             border: 'none', borderRadius: 4, marginRight: 8, cursor: 'pointer' }}>
              Salvar
            </button>
            <button onClick={publicar}
                    style={{ background: '#f39c12', color: '#fff', padding: '10px 20px',
                             border: 'none', borderRadius: 4, cursor: 'pointer' }}>
              Publicar
            </button>
          </>
        )}
      </div>

      <h2>Projetos incluídos</h2>
      {r.projetos?.length === 0 && <p>Sem projetos associados.</p>}
      <ul style={{ background: '#fff', padding: 16, borderRadius: 8, listStyle: 'none' }}>
        {r.projetos?.map((p) => (
          <li key={p.projeto_id} style={{ padding: 8, borderBottom: '1px solid #eee' }}>
            {p.destaque && <span style={{ background: '#f39c12', color: '#fff', padding: '2px 6px',
                                           borderRadius: 4, fontSize: '0.7rem', marginRight: 6 }}>DESTAQUE</span>}
            <Link to={`/inovacao/projetos/${p.projeto_id}`} style={{ color: 'var(--brand, #20a490)' }}>{p.nome_projeto}</Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
